import Seo from "@/components/Seo";

export default function Historia() {
  return (
    <>
      <Seo
        title="A nossa história | Doce Casa"
        siteName="Doce Casa"
        description="A história da Doce Casa: pastelaria artesanal nascida do conforto da cozinha, feita com as mãos e com o coração."
      />

      <section className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-12 py-16 md:py-24" data-testid="story-page">
        <div className="grid gap-12 lg:grid-cols-[1.15fr_1fr] items-center">
          <div className="animate-rise">
            <h1 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-chocolate">
              A nossa história
            </h1>

            <div className="mt-8 space-y-6 text-base sm:text-lg leading-relaxed text-cocoa">
              <p>
                Para mim, a pastelaria começou por ser um lugar de conforto. Há
                dias em que preciso de abrandar, afastar por um momento o ruído
                lá de fora e fazer algo com as mãos e com o coração. Na cozinha,
                entre aromas, massas e pequenos detalhes, encontro essa paz.
              </p>
              <p>
                Comecei por fazer doces para as pessoas de quem gosto. Um bolo
                para celebrar, uma sobremesa para partilhar à mesa ou
                simplesmente um miminho num dia difícil. Fui percebendo que um
                doce pode guardar muito mais do que um sabor: pode recordar uma
                tarde feliz, trazer a sensação de estar em casa ou saber a um
                abraço de mãe.
              </p>
              <p>
                Foi assim que nasceu a <strong className="font-semibold text-chocolate">Doce Casa</strong>.
                Quero partilhar com outras pessoas o carinho que ponho em cada
                receita. Quero que os meus bolos estejam presentes nos dias que
                merecem festa, mas também naqueles em que apetece parar,
                respirar e oferecer a nós próprios um momento bom.
              </p>
              <p>
                Talvez um dia te lembres de um bolo da Doce Casa porque o
                partilhaste com quem amas. Ou porque, quando mais precisavas de
                aconchego, uma fatia soube exatamente a isso: a casa.
              </p>
            </div>

            <p
              className="mt-10 inline-block rounded-2xl bg-beige border border-sand px-7 py-5 font-hand text-2xl sm:text-3xl text-terracotta"
              data-testid="story-highlight"
            >
              Doce Casa — Um doce com cheirinho de casa.
            </p>
          </div>

          <div className="relative animate-rise" style={{ animationDelay: "0.15s" }}>
            <div className="absolute -inset-3 rounded-[2.75rem] bg-beige -rotate-2" aria-hidden="true" />
            <img
              src="/images/bolo-nuvem.jpg"
              alt="Bolo nuvem de chocolate artesanal com cobertura cremosa de mascarpone, fatiado num prato de bolo branco"
              loading="lazy"
              className="relative w-full aspect-square object-cover rounded-[2.5rem] shadow-[0_30px_60px_-25px_rgba(61,35,20,0.35)]"
              data-testid="story-image"
            />
          </div>
        </div>
      </section>
    </>
  );
}
